export default __webpack_public_path__ + "static/user-paths-light-96ac95134e80cd564bc9a8f7de47bae6.png";